"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableFranchiseCell = void 0;
var bc_data_table_constants_1 = require("../bc-data-table-constants");
var common_constants_1 = require("../../../../common/constants/common-constants");
var BcDataTableFranchiseCell = (function () {
    function BcDataTableFranchiseCell() {
    }
    BcDataTableFranchiseCell.prototype.render = function (cell) {
        var bodyStyles = getComputedStyle(document.body);
        this.themeColor = bodyStyles.getPropertyValue('--bc-theme-color');
        var newCell = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
        var cellContainerDiv = this.createCellContainerDiv(cell);
        newCell.appendChild(cellContainerDiv);
        return newCell;
    };
    BcDataTableFranchiseCell.prototype.createCellContainerDiv = function (cell) {
        var cellContainerDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        cellContainerDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CELL_FRANCHISE_DIV_CONTAINER);
        var iconImg = this.createIconImage(cell);
        var textP = this.createTextParagraph(cell);
        cellContainerDiv.appendChild(iconImg);
        cellContainerDiv.appendChild(textP);
        return cellContainerDiv;
    };
    BcDataTableFranchiseCell.prototype.createIconImage = function (cell) {
        var iconImg = document.createElement(common_constants_1.BcCommonConstants.IMG_TAG);
        iconImg.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTRIBUTE_ALT, cell.value.toString());
        if (this.themeColor === 'white') {
            iconImg.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTRIBUTE_SRC, cell.path.toString());
        }
        else if (cell.pathBlack) {
            iconImg.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTRIBUTE_SRC, cell.pathBlack.toString());
        }
        else {
            iconImg.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTRIBUTE_SRC, cell.path.toString());
        }
        return iconImg;
    };
    BcDataTableFranchiseCell.prototype.createTextParagraph = function (cell) {
        var textP = document.createElement(common_constants_1.BcCommonConstants.P_TAG);
        textP.textContent = cell.value.toString();
        return textP;
    };
    return BcDataTableFranchiseCell;
}());
exports.BcDataTableFranchiseCell = BcDataTableFranchiseCell;
